// black/white is masking color
export const BLACK_COLOR = 'rgb(0, 0, 0)';
export const WHITE_COLOR = 'rgb(255, 255, 255)';
